import { render } from "./autoExtract.vue?vue&type=template&id=39e10216&scoped=true"
import script from "./autoExtract.vue?vue&type=script&lang=js"
export * from "./autoExtract.vue?vue&type=script&lang=js"

import "./autoExtract.vue?vue&type=style&index=0&id=39e10216&scoped=true&lang=css"

import exportComponent from "/Users/andrew/Documents/Code/SeoBiz/AdminApp/FrontEnd/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e10216"]])

export default __exports__